export const TIME_OPTIONS = [
  '10 min',
  '1 hour',
  '24 hours',
  '20 min',
  '2 hours',
  '36 hours',
  '30 min',
  '4 hours',
  '48 hours',
  '45 min',
  '12 hours',
  '72 hours',
];

// TODO: Confirm whether the escape character can be removed safely and then remove the lint disable
// eslint-disable-next-line no-useless-escape
export const BUCKET_NAME_REGEXP = /(?=^.{3,63}$)(?!^(\d+\.)+\d+$)(^(([a-z0-9]|[a-z0-9][a-z0-9\-]*[a-z0-9])\.)*([a-z0-9]|[a-z0-9][a-z0-9\-]*[a-z0-9])$)/;
